import { render, staticRenderFns } from "./BlwUpload.vue?vue&type=template&id=2a53a022&"
import script from "./BlwUpload.vue?vue&type=script&lang=js&"
export * from "./BlwUpload.vue?vue&type=script&lang=js&"
import style0 from "./BlwUpload.vue?vue&type=style&index=0&id=2a53a022&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports